var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowLeft(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.18729 10.2803L6.68895 9.75L6.18729 9.21967C5.91023 9.51256 5.91023 9.98744 6.18729 10.2803ZM7.69228 9.75L13.8122 3.28033C14.0893 2.98744 14.0893 2.51256 13.8122 2.21967C13.5352 1.92678 13.086 1.92678 12.8089 2.21967L6.18729 9.21967C6.18726 9.2197 6.18729 9.21967 6.68895 9.75C6.18729 10.2803 6.18726 10.2803 6.18729 10.2803L12.8089 17.2803C13.086 17.5732 13.5352 17.5732 13.8122 17.2803C14.0893 16.9874 14.0893 16.5126 13.8122 16.2197L7.69228 9.75Z",
    fill: "#676879"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLeft);
export default __webpack_public_path__ + "static/media/arrow-left.816cdf43.svg";
export { ForwardRef as ReactComponent };